import React from 'react'
import Popover from '@mui/material/Popover'
import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: Theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(2),
    color: 'white',
    background: 'black',
    fontSize: 14,
  },
}))

export type OnMousePopoverProps = {
  /**
   * ポップオーバーの内容
   */
  popover: React.ReactNode
  /**
   *  trueの時ポップオーバーが無効になる
   */
  disabled?: boolean
  /**
   * マウスオーバーされる内容（ボタン、アイコン、テキストなど）
   */
  children: React.ReactNode
}

const OnMousePopover: React.FC<OnMousePopoverProps> = ({
  children,
  disabled,
  popover,
}: OnMousePopoverProps) => {
  const { classes } = useStyles()
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  if (disabled) {
    return <>{children}</>
  }

  return (
    <>
      <span
        aria-owns={open ? 'mouse-over-popover' : undefined}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {children}
      </span>
      <Popover
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 27,
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {popover}
      </Popover>
    </>
  )
}

export default OnMousePopover
